var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ModuleHeader from '../../components/ModuleHeader/ModuleHeader';
import { Box, Divider, List, ListItemButton, ListItemText, Typography } from '@mui/material';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { utility } from '../../utils';
import { user_actions } from '../../actions/user_actions';
import PermissionsBox from './PermissionsDialog';
import constants from '../../config/constants';
var processPermissions = function (permissions) {
    if (!permissions || !Array.isArray(permissions)) {
        return [];
    }
    var permissionMap = new Map();
    var getOrCreateNode = function (key, name) {
        var _a, _b;
        if (!permissionMap.has(key)) {
            permissionMap.set(key, {
                PermissionKey: key,
                PermissionName: name || ((_b = (_a = key.split(':').pop()) === null || _a === void 0 ? void 0 : _a.replace(/_/g, ' ')) === null || _b === void 0 ? void 0 : _b.replace(/\b\w/g, function (l) { return l.toUpperCase(); })),
                View: 0, Add: 0, Update: 0, Delete: 0,
                SubModules: []
            });
        }
        return permissionMap.get(key);
    };
    permissions.forEach(function (perm) {
        var _a, _b, _c, _d;
        var node = getOrCreateNode(perm.PermissionKey, perm.PermissionName);
        node.PermissionId = perm.PermissionId;
        node.View = (_a = perm.View) !== null && _a !== void 0 ? _a : 0;
        node.Add = (_b = perm.Add) !== null && _b !== void 0 ? _b : 0;
        node.Update = (_c = perm.Update) !== null && _c !== void 0 ? _c : 0;
        node.Delete = (_d = perm.Delete) !== null && _d !== void 0 ? _d : 0;
        Object.assign(node, __assign(__assign({}, perm), { PermissionKey: perm.PermissionKey, PermissionName: node.PermissionName }));
    });
    var keys = Array.from(permissionMap.keys()).sort(function (a, b) { return a.split(':').length - b.split(':').length; });
    var roots = [];
    keys.forEach(function (key) {
        var parts = key.split(':');
        if (parts.length === 1) {
            roots.push(permissionMap.get(key));
        }
        else {
            var parentKey = parts.slice(0, -1).join(':');
            var parent_1 = getOrCreateNode(parentKey);
            var self_1 = permissionMap.get(key);
            if (!parent_1.SubModules.find(function (s) { return s.PermissionKey === key; })) {
                parent_1.SubModules.push(__assign(__assign({}, self_1), { SubModuleName: self_1.PermissionName }));
            }
            if (parentKey.split(':').length === 1 && !roots.includes(parent_1)) {
                roots.push(parent_1);
            }
        }
    });
    var updateParentPermissions = function (node) {
        if (node.SubModules && node.SubModules.length > 0) {
            node.SubModules.forEach(function (sub) { return updateParentPermissions(sub); });
            if (node.View === 0 && node.Add === 0 && node.Update === 0 && node.Delete === 0) {
                node.View = node.SubModules.some(function (s) { return s.View === 1; }) ? 1 : 0;
                node.Add = node.SubModules.some(function (s) { return s.Add === 1; }) ? 1 : 0;
                node.Update = node.SubModules.some(function (s) { return s.Update === 1; }) ? 1 : 0;
                node.Delete = node.SubModules.some(function (s) { return s.Delete === 1; }) ? 1 : 0;
            }
        }
    };
    roots.forEach(function (root) { return updateParentPermissions(root); });
    return roots;
};
var RolesPermissions = function () {
    var dispatch = useDispatch();
    var userBasicInfo = useSelector(function (store) { return store.User; });
    var userData = userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.userData;
    var rolePermissions = (userData === null || userData === void 0 ? void 0 : userData.RolePermissions) || [];
    var adminPermission = rolePermissions.find(function (perm) { return perm.PermissionKey === 'ADMINISTRATOR:ADMIN_MGMT:ROLES_PERMISSIONS'; });
    var canView = (adminPermission === null || adminPermission === void 0 ? void 0 : adminPermission.View) === 1 || (userData === null || userData === void 0 ? void 0 : userData.RoleType) === 'ADMIN';
    var canUpdate = (adminPermission === null || adminPermission === void 0 ? void 0 : adminPermission.Update) === 1 || (userData === null || userData === void 0 ? void 0 : userData.RoleType) === 'ADMIN';
    var _a = useState([]), rolesList = _a[0], setRolesList = _a[1];
    var _b = useState([]), freezedList = _b[0], setFreezedList = _b[1];
    var _c = useState(false), isFetching = _c[0], setIsFetching = _c[1];
    var _d = useState(false), dialogOpen = _d[0], setDialogOpen = _d[1];
    var _e = useState(null), dialogRole = _e[0], setDialogRole = _e[1];
    var _f = useState(null), selectedRoleId = _f[0], setSelectedRoleId = _f[1];
    var getApplicationRolesList = function () {
        setIsFetching(true);
        setRolesList([]);
        api_service.get({
            endPoint: api_urls.ROLE_PERMISSIONS,
            payLoad: {}
        })
            .then(function (res) {
            setIsFetching(false);
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                var __rolesResponse = res.data.data || [];
                var mappedRoles = __rolesResponse.map(function (role) {
                    var processedPermissions = processPermissions(role.PermissionList || []);
                    return {
                        RoleId: role.RoleId,
                        RoleType: role.RoleType,
                        RoleName: role.RoleName,
                        RoleDescription: role.RoleDescription,
                        UserCount: role.UserCount === 0 || role.UserCount === '0' ? '0' : role.UserCount,
                        RolePermissions: processedPermissions
                    };
                });
                setRolesList(mappedRoles);
                setFreezedList(mappedRoles);
                if (mappedRoles.length > 0) {
                    var matchedRole = mappedRoles.find(function (role) { return role.RoleType === (userData === null || userData === void 0 ? void 0 : userData.RoleType); })
                        || mappedRoles[0];
                    setSelectedRoleId(matchedRole.RoleId);
                    setDialogRole(matchedRole);
                    setDialogOpen(true);
                }
            }
            else {
                utility.alert('Failed to fetch roles', 'error');
            }
        })
            .catch(function (err) {
            utility.alert('Failed to fetch roles. Please try again.', 'error');
            setIsFetching(false);
        });
    };
    var updateRolePermissions = function (roleId, updatedList, originalList) {
        setIsFetching(true);
        var permissions = [];
        var permissionKeys = ['View', 'Add', 'Update', 'Delete'];
        var collectAllSubModules = function (modules) {
            modules.forEach(function (module) {
                var _a;
                if (module.PermissionId) {
                    permissions.push({
                        PermissionId: module.PermissionId,
                        View: Number(module.View),
                        Add: Number(module.Add),
                        Update: Number(module.Update),
                        Delete: Number(module.Delete),
                    });
                }
                if ((_a = module.SubModules) === null || _a === void 0 ? void 0 : _a.length) {
                    collectAllSubModules(module.SubModules);
                }
            });
        };
        var collectChanges = function (updatedModules, originalModules) {
            updatedModules.forEach(function (module, index) {
                var _a, _b, _c;
                var original = originalModules[index];
                if (!original)
                    return;
                var hasModuleChange = false;
                var changedModule = {};
                permissionKeys.forEach(function (key) {
                    if (module[key] !== original[key]) {
                        changedModule[key] = Number(module[key]);
                        hasModuleChange = true;
                    }
                });
                if (hasModuleChange) {
                    if (module.PermissionId) {
                        var alreadyAdded = permissions.some(function (p) { return p.PermissionId === module.PermissionId; });
                        if (!alreadyAdded) {
                            permissions.push({
                                PermissionId: module.PermissionId,
                                View: Number(module.View),
                                Add: Number(module.Add),
                                Update: Number(module.Update),
                                Delete: Number(module.Delete),
                            });
                        }
                    }
                    if ((_a = module.SubModules) === null || _a === void 0 ? void 0 : _a.length) {
                        collectAllSubModules(module.SubModules);
                        return;
                    }
                }
                if (((_b = module.SubModules) === null || _b === void 0 ? void 0 : _b.length) && ((_c = original.SubModules) === null || _c === void 0 ? void 0 : _c.length)) {
                    collectChanges(module.SubModules, original.SubModules);
                }
            });
        };
        collectChanges(updatedList, originalList);
        var deduped = Array.from(permissions
            .reduce(function (map, p) { return map.set(p.PermissionId, p); }, new Map())
            .values());
        if (!deduped.length) {
            setIsFetching(false);
            utility.alert('No changes detected', 'info');
            return;
        }
        var payload = {
            RoleId: Number(roleId),
            Permissions: deduped,
        };
        api_service.put({
            endPoint: api_urls.ROLE_PERMISSIONS,
            payLoad: payload,
        })
            .then(function (res) {
            var _a;
            setIsFetching(false);
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                setRolesList(function (prev) {
                    return prev.map(function (role) {
                        return role.RoleId === roleId
                            ? __assign(__assign({}, role), { RolePermissions: updatedList }) : role;
                    });
                });
                setFreezedList(function (prev) {
                    return prev.map(function (role) {
                        return role.RoleId === roleId
                            ? __assign(__assign({}, role), { RolePermissions: updatedList }) : role;
                    });
                });
                setDialogRole(function (prev) {
                    return (prev === null || prev === void 0 ? void 0 : prev.RoleId) === roleId
                        ? __assign(__assign({}, prev), { RolePermissions: updatedList }) : prev;
                });
                utility.alert('Permissions updated successfully', constants.TOAST_TYPES.INFO);
                setIsFetching(true);
                api_service.get({
                    endPoint: api_urls.ROLE_PERMISSIONS,
                    payLoad: {}
                })
                    .then(function (refreshRes) {
                    setIsFetching(false);
                    if ((refreshRes === null || refreshRes === void 0 ? void 0 : refreshRes.data) && refreshRes.data.statusCode === 200) {
                        var __rolesResponse = refreshRes.data.data || [];
                        var mappedRoles = __rolesResponse.map(function (role) {
                            var processedPermissions = processPermissions(role.PermissionList || []);
                            return {
                                RoleId: role.RoleId,
                                RoleType: role.RoleType,
                                RoleName: role.RoleName,
                                RoleDescription: role.RoleDescription,
                                UserCount: role.UserCount === 0 || role.UserCount === '0' ? '0' : role.UserCount,
                                RolePermissions: processedPermissions
                            };
                        });
                        setRolesList(mappedRoles);
                        setFreezedList(mappedRoles);
                        var updatedRole = mappedRoles.find(function (r) { return r.RoleId === roleId; });
                        if (updatedRole) {
                            setDialogRole(updatedRole);
                            if ((userData === null || userData === void 0 ? void 0 : userData.RoleType) === updatedRole.RoleType) {
                                var rawUpdatedRole = __rolesResponse.find(function (r) { return r.RoleId === roleId; });
                                dispatch(user_actions.syncRolePermissions((rawUpdatedRole === null || rawUpdatedRole === void 0 ? void 0 : rawUpdatedRole.PermissionList) || []));
                            }
                        }
                    }
                })
                    .catch(function () {
                    setIsFetching(false);
                });
            }
            else {
                utility.alert((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.message, constants.TOAST_TYPES.ERROR);
            }
        })
            .catch(function (err) {
            utility.alert(err, constants.TOAST_TYPES.ERROR);
            setIsFetching(false);
        });
    };
    var handleRoleSelect = function (role) {
        var _a;
        var permsCount = ((_a = role.RolePermissions) === null || _a === void 0 ? void 0 : _a.length) || 0;
        setSelectedRoleId(role.RoleId);
        setDialogRole(role);
        setDialogOpen(true);
        if (permsCount === 0) {
            console.warn('No permissions for role:', role.RoleName);
        }
    };
    useEffect(function () {
        getApplicationRolesList();
    }, []);
    return (React.createElement(Box, { className: "common-module-wrapper admin-management-wrapper", sx: {
            display: 'flex',
            height: '74vh',
            flexDirection: "column"
        } },
        React.createElement(ModuleHeader, { sx: { minHeight: "auto" }, moduleName: 'Roles & Permissions', moduleDescription: 'Manage user roles & feature-level access permissions', placeHolderText: '' }),
        React.createElement(Divider, null),
        React.createElement(Box, { display: "flex", flexDirection: "row", height: "88%" },
            React.createElement(Box, { sx: {
                    width: 250,
                    minWidth: 250,
                    maxWidth: 250,
                    flexShrink: 0,
                    borderRight: '1px solid #e0e0e0',
                    display: 'flex',
                    flexDirection: 'column',
                    bgcolor: '#f9fafb',
                    height: '100%'
                } },
                React.createElement(Box, { sx: {
                        px: 2,
                        pt: "9px",
                        pb: "10px",
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    } },
                    React.createElement(Typography, { variant: "subtitle1", fontWeight: 600 }, "Roles")),
                React.createElement(Divider, null),
                React.createElement(List, { sx: { flex: 1, overflowY: 'auto', py: 0 } }, isFetching ? (React.createElement(Box, { sx: { p: 2, textAlign: 'center' } },
                    React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "Loading roles..."))) : rolesList.length === 0 ? (React.createElement(Box, { sx: { p: 2, textAlign: 'center' } },
                    React.createElement(Typography, { variant: "body2", color: "text.secondary" }, "No roles found"))) : (rolesList.map(function (role) { return (React.createElement(ListItemButton, { key: role.RoleId, selected: selectedRoleId === role.RoleId, onClick: function () { return handleRoleSelect(role); }, sx: {
                        padding: "12px 6px 12px 24px",
                        borderBottom: "1px solid #DADADA",
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#4F4F4F",
                        backgroundColor: "#fff",
                        borderRadius: 0,
                        borderRight: selectedRoleId === role.RoleId
                            ? '4px solid #1976d2'
                            : '4px solid transparent',
                        pl: 2,
                        '&.Mui-selected': {
                            backgroundColor: "#1F275C",
                            color: "#fff",
                            '&:hover': {
                                backgroundColor: "#1F275C",
                                color: "#fff",
                            },
                        }
                    } },
                    React.createElement(ListItemText, { sx: { margin: 0 }, primary: React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 },
                            React.createElement(Typography, { fontWeight: 500, fontSize: 14 }, role.RoleName),
                            React.createElement(Typography, { fontSize: 12 }, role.UserCount)) }))); })))),
            !selectedRoleId ? (React.createElement(Box, { sx: {
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                    flexDirection: "column",
                    mt: 5,
                } },
                React.createElement(Box, { sx: {
                        width: 72,
                        height: 72,
                        mx: 'auto',
                        mb: 2,
                        borderRadius: '50%',
                        bgcolor: 'rgba(25,118,210,0.08)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    } },
                    React.createElement(Typography, { fontSize: 32, color: "primary" }, "\uD83D\uDEE1\uFE0F")),
                React.createElement(Typography, { fontWeight: 600, fontSize: 18, mb: 1 }, "No Role Selected"),
                React.createElement(Typography, { fontSize: 14, color: "text.secondary", mb: 3, textAlign: "center", px: 4 }, "Select a role from the list to view and manage its permissions."))) : (selectedRoleId && dialogRole && (React.createElement(PermissionsBox, { open: dialogOpen, onClose: function () {
                    setDialogOpen(false);
                    setSelectedRoleId(null);
                    setDialogRole(null);
                }, roleName: dialogRole.RoleName, roleType: dialogRole.RoleType, permissions: dialogRole.RolePermissions, canUpdate: canUpdate, onSave: function (updatedPerms) {
                    if (!dialogRole)
                        return;
                    updateRolePermissions(dialogRole.RoleId, updatedPerms, dialogRole.RolePermissions);
                } }))))));
};
export default RolesPermissions;
